export default {
    badge: "märk",
    close: "Sulge",
    dataIterator: {
        noResultsText: "Ühtegi sobivat kirjet ei leitud",
        loadingText: "Kiri laaditakse..."
    },
    dataTable: {
        itemsPerPageText: "Rida lehekülje kohta:",
        ariaLabel: {
            sortDescending: "Sorteeritud kahanevas järjekorras.",
            sortAscending: "Sorteeritud kasvavas järjekorras.",
            sortNone: "Pole sorteeritud.",
            activateNone: "Aktiveerige sortimise eemaldamiseks.",
            activateDescending: "Aktiveerige kahanevalt sortimiseks.",
            activateAscending: "Aktiveerige kasvavalt sortimiseks.",
        },
        sortBy: "Sorteeri",
    },
    dataFooter: {
        itemsPerPageText: "Sissekanded leheküljel:",
        itemsPerPageAll: "Kõik",
        nextPage: "Järgmine lehekülg",
        prevPage: "Eelmine lehekülg",
        firstPage: "simene lehekülg",
        lastPage: "Viimane lehekülg",
        pageText: "{0}-{1} из {2}"
    },
    datePicker: {
        itemsSelected: "{0} valeted",
        nextMonthAriaLabel: "Järgmine kuu",
        nextYearAriaLabel: "Järgmine aasta",
        prevMonthAriaLabel: "Eelmime kuu",
        prevYearAriaLabel: "Eelmine aasta"
    },
    noDataText: "Andmed puuduvad",
    carousel: {
        prev: "Eelmine slaid",
        next: "Järgmine slaid",
        ariaLabel: {
            delimiter: "Slaid {0} {1} -st"
        }
    },
    calendar: {
        moreEvents: "Veel {0}"
    },
    fileInput: {
        counter: "Faile: {0}",
        counterSize: "Faile: {0} (kokku {1})"
    },
    timePicker: {
        am: "AM",
        pm: "PM"
    },
    pagination: {
        ariaLabel: {
            wrapper: "Navigeerimine leheküljel",
            next: "Järgmine lehekülg",
            previous: "Eelmine lehekülg",
            page: "Mine leheküljele {0}",
            currentPage: "Praegune lehekplg, lehekülg {0}"
        }
    },
    rating: {
        ariaLabel: {
            icon: "Reiting {0} {1} -st"
        }
    },

    start: "Algus",
    deadline: "Deadline",
    sure: "Kas olete kindel",
    sureArchive: "Kinnitage arhiveerimine",
    sureOutArchive: "Kinnitage eemaldamist arhiivist",
    yes: "jah",
    value: "Tähendus",
    addNew: "Lisa uudis",
    uploadNewsImage: "Vali pilt (jpg, png)",
    publish: "Avalda",
    title: "Pealkiri",
    addEvent: "Lisa sündmus",
    today: "Tänä",
    month: "Kuu",
    day: "Päev",
    addingEvent: "Sündmuse lisamine",
    editingEvent: "Sündmuse toimetamine",
    deletingEvent: "Sündmuse eemaldamine",
    time: "Aeg",
    endDate: "Lõppkuupäev",
    allDay: "Kogu päev",
    period: "Tähtaeg",
    confirmDeleteEvent: "Kas olete kindel, et soovite valitud sündmuse kustutada? Seda toimingut on võimatu tagasi teha.",
    forWhomRule: "Valige, kellele sündmus on mõeldud",
    forWhom: "Kelle jaoks",
    forSelf: "Enda jaoks",
    forGroup: "Rühma jaoks",
    forAll: "Kõikide jaoks",
    forUser: "Kasutaja jaoks",
    description: "Kirjeldus",
    confirm: "Kinnita tunnid",
    aboutObject: "Objekti kohta",
    worksEnd: "Tööde lõpetamiskuupäev",
    worksEndLate: "Lõppkuupäev viivitusega",
    worksStart: "Tööde alustamispäev",
    objectName: "Töömaa nimetus",
    square: "Meeter",
    accidentInsurance: "Õnnetusjuhtumikindlustus",
    healthInsurance: "Tervisekindlustus",
    habitation: "Elamine",
    number: "Number",
    name2: "Firma nimi",
    shortName: "Lühinimi",
    position: "Amet",
    name: "Nimi",
    surname: "Perekonnanimi",
    no: "ei",
    have: "on",
    phone: "Telefoni nr",
    email: "E-mail",
    ogrn: "Registreerimisnumber",
    address: "Address",
    staff: "Personaal",
    documents: "Dokumendid",
    planning: "Planeeritakse",
    inProgress: "Protsessis",
    finished: "Lõpetatud",
    back: "Tagasi",
    cancel: "Tühista",
    forward: "Edasi",
    documentName: "Dokumendi nimetus",
    documentType: "Dokumendi tüüp",
    dateDownload: "Üleslaadimise kuupäev",
    objectNumber: "Töömaa nr",
    objectAddress: "Töömaa aadress",
    client: "Klient",
    clientPhone: "Kliendi telefoni nr",
    clientEmail: "Kliendi e-mail",
    employesOnObject: "Töötajad objektil",
    workList: "Tööde kirjeldus",
    comments: "Kommentaarid",
    comment: "Kommentaar",
    news: "Uudised",
    readAlso: "Samuti loe",
    save: "Salvesta",
    addCard: "Lisa kaart",
    addWork: "Salvesta töökirjeldus",
    addEmployee: "Lisa töötaja",
    addObject: "Salvesta töömaa",
    editObject: "Muuda objekti andmed",
    addContact: "Lisa kontakt",
    editContact: "Muuda kontakti andmed",
    addGroup: "Lisa rühm",
    editGroup: "Munda rühmt andmed",
    addTimeReport: "Lisa uus aruanne",
    editTimeReport: "Muuda aruanne",
    addClient: "Lisa uus klient",
    addDocument: "Lisa uus dokument",
    add: "Lisa",
    changePhoto: "Muuda foto",
    changeSignature: "Muuda allkiri",
    changeDocument: "Muuda dokument",
    bankAccount: "Pangaarve nr.",
    systemRole: "Roll süsteemis",
    aboutEmployee: "Töötaja andmed",
    cards: "Kaardid ja läbipääsmed",
    skills: "Oskused",
    roof: "Katuse ehitus",
    floor: "Põrandakatted",
    personalInfo: "Isiklik info",
    citizenship: "Kodakondsus",
    birthday: "Sünnipäev",
    addressOwn: "Elukoha aadress koduriigis",
    addressFin: "Elukoha aadress Soomes",
    otherPhone: "Lisatelefoninumber",
    additional: "Lisaks",
    driverLicense: "Juhiluba",
    driverLicenseCat: "Juhiloa kategooria",
    ownCar: "Isiklik auto",
    ownTools: "Isiklik instrument",
    haveOwnCar: "Oma auto",
    haveOwnTools: "Isiklik instrument",
    languages: "Keeleoskused",
    uniform: "Tööriided",
    editPersonal: "Muuda isimlik info",
    editAdditional: "Muuda lisainfo",
    fromFinland: "Olen Soomest",
    fromAnotherCountry: "Olen teisest riigist",
    socialCodeFin: "Soome henkilötunnus",
    taxNumber: "Veronumero",
    street: "Tänav",
    house: "Maja nr",
    flat: "Korteri nr",
    entrance: "Treppikoja nr",
    index: "Indeks",
    city: "Linn",
    country: "Riik",
    sizeUniform: "Tööriiete suurus",
    size: "Suurus",
    shirt: "T-särk",
    pants: "Püksid",
    jacket: "Jope",
    boots: "Kingad",
    gloves: "Kindad",
    cardNumber: "Dokumendi nr",
    dueDate: "Kehtivuse aeg",
    uploadImg: "Lae foto (jpg, png)",
    changeImg: "Muuda foto (jpg, png)",
    deleteCard: "Eemalda kaart",
    paintingWorks: "Maalritööd",
    outdoor: "Õuetööd",
    indoor: "Sisetööd",
    plastering: "Krohvimistööd",
    manual: "Käsi",
    hardware: "Apparaati",
    facade_plasteir: "Fassaadi krohv",
    chain: "Metall võrguga",
    plasterboard: "Klaaskuttu vürguga",
    alignment: "Joondus",
    carpentry: "Puusepatööd",
    simple: "Tavalised",
    formwork: "Salungaga",
    suspendedCeilings: "Ripplaed",
    giprok: "Gyprok",
    panels: "Paneelid",
    partitionWalls: "Vaheseinad",
    tileWaterproofing: "Plaadid + hüdroisolatsioon",
    Floor: "Põrandakate",
    parquet: "Parkett",
    laminate: "Laminaat",
    masonry: "Kivide ja telliste ladumine",
    concrete_works: "Betonitööd",
    reinforcement: "Armeerimine",
    tiles: "Katusekivid",
    metal: "Metall",
    bitumen: "Bitumitööd",
    bitumen_roof: "Katus",
    bitumen_plinth: "Sokkel",
    welding: "Keevitus",
    diamondCuttingDrilling: "Teemantlõikamine ja puurimine",
    fillForm: "Täitke kõik nõutavad väljad",
    addDocumentRule: "Lisa dokument",
    required: "Kohustuslik väli",
    enterText: "Sisestage oma sõnum",
    enterWorkText: "Sisestage töökirjeldus",
    lettersOnly: "Sisestage ainult tähestikulised tähemärgid",
    incorrectEmail: "Vale E-mail",
    companyName: "Firma nimi",
    activityType: "Tegevusala",
    regNumber: "Reg. nr",
    website: "Website",
    logo: "Logo",
    editClient: "Muuda kliendi anded",
    edit: "Muuda",
    delete: "Eemalda",
    surnameName: "Nimi, perekonnanimi",
    speciality: "Amet",
    company: "Firma nimi",
    mainInfo: "Üldinfo",
    downloadDocument: "Vali dokument (pdf, doc, docx, jpg)",
    downloadPhoto: "Lae pilt alla (jpg, png)",
    date: "Kuupäev",
    workType: "Tehtud tööd",
    selectObjectLabel: "Objekti aadress",
    selectWorker: "Vali töötaja",
    selectClient: "Vali firma",
    selectContact: "Vali kontakt",
    wages: {
        label: "Maksetüüp",
        piecework: "Tükkitöö",
        hourly: "Tunnitlöö",
        fixed: "Fikseeritud palk",
        sum: "Palk",
        rate: "Hind",
        quantity: "Kogus",
        measurement: "Ühik",
        hours: "Tunde",
        time: "Aeg (t)"
    },
    measurements: {
        kg: "kg",
        g: "g",
        m: "m",
        m2: "m2",
        m3: "m3",
        pc: "tk",
        rll: "rul"
    },
    typeBody: "Keretüüp",
    vin: "VIN nr",
    regData: "Registreerimis andmed",
    carView: "Välimus",
    carTechnic: "Tehnilised andmed",
    carDocuments: "Dokumendid auto kohta",
    regDate: "Registreerimise kuupäev",
    odometer: "Odomeetri näide (km)",
    engine: "Mootor",
    fuel: "Kütus",
    typeDrive: "Vedu",
    transmission: "Käigukast",
    color: "Taustavärv",
    characteristics: "Omadused",
    sorts: {
        sortBy: "Sorteeri",
        search: "Otsing",
        searchMan: "Otsing nime, telefoni või e-posti järgi",
        searchWorker: "Otsing töötaja nime järgi",
        searchObject: "Otsing nimetuse, numbri või aadressi järgi",
        searchCar: "Otsing nime, numbri või vin järgi",
        searchName: "Otsi nime, numbri järgi",
        searchWaybills: "Otsing aadressite järgi",
        searchContracts: "Otsing dokumendi nimetuse järgi",
        searchDocuments: "Otsing dokumendi nimetuse järgi",
        byObjects: "objekti",
        byWorkType: "too tüüpi",
        bySum: "makse",
        byTotalSum: "summa",
        byDate: "kuupäeva",
        byCreateDate: "lisamise järgi",
        byStartDate: "alguskuupäeva järgi",
        byRegDate: "registreerimis kuupäeva",
        byCategory: "kategooria",
        byAccountant: "raamatupidaja nime",
        byBank: "pankka",
        byName: "nimetuse järgi",
        bySubject: "subjekti",
        byClient: "kliendi",
        byStatus: "staatuse",
        byAddress: "addressi",
        byCost: "hinna",
        byCar: "auto",
        byFullName: "nime",
        byWorkerPosition: "eriala",
        byContactPosition: "ameti",
        byMileage: "läbisõidu",
        byNumber: "numbri",
        byBranch: "tegevuse",
        byCompany: "firma",
        byType: "dokumendi tüüpi",

        byPhone: "telefoni järgi",
        byEmail: "e-maili järgi",
        byRegNumber: "reg number järgi",
    },
    menu: {
        'holidays': 'Puhkus',

        charts: 'graafika',

        main: "Pealeht",
        news: "Uudised",
        "news-item": "uudis",
        "news-add": "Lisa uudis",
        "news-edit": "Redakteeri uudis",
        workers: "Töötajad",
        "workers-item": "Töötaja",
        "worker-timings": "Töötaja tunniaruanded",
        clients: "Märkmik",
        "clients-item": "Klient",
        partners: "Partnerid",
        contacts: "Kontaktid",
        objects: "Objektid",
        "objects-item": "Objekt",
        "object-timings": "Objekti tunniaruanded",
        calendar: "Kalender",
        faq: "Abi",
        timings: "Töö aruanne",
        accounting: "Raamatupidamine",
        settings: "Seaded",
        "settings-item": "Seaded",
        waybills: "Saatelehed",
        addWaybill: "Lisa saateleht",
        BookkeepingView: "Raamatupidamine",
        documents: "Dokumendid",
        'documents-absence': "Dokumendid",
        'documents-timings': "Töö aruanne",
        addBookkeeping: "Lisa dokument",
        garage: "Garaaž",
        "garage-item": "Garaaž",
        profile: "Profiil",
        'clients-profile': "Profiil",
        groups: "Rühmad",
        AuthLayout: "Autoriseerimine",
        ResetPassword: "Uuenda parool",
        SignUpLayout: "Registreerimine",
        SignUpTenantLayout: "Registreerimine",
        404: "Leht ei ole leitud",
        useful: "Kasulikud lingid",
        absence: "Puudumine",
        TechnicalWorks: "Tehnilised tööd",
        todo: "ToDo List",
        "todo-object": "ToDo List",
        catalog: "Kataloog",
        addOrder: "Lisa tellimus",
        editOrder: "Muuda tellimus",
        businessCards: "Visiitkaardid",
        tenants: "Kliendid",
        tariffPlans: "Tariifiplaanid",
        organizations: "Firmad",
        company: "Ettevõtte andmed",
        SuccessLayout: "Maksmine õnnestus",
        ErrorLayout: "Makseviga",
        safe: "Seiff",
        notifications: "Märguanded",
        SelectCompany: "Valige firma",
        timingChangesList: "Tunniaruande muudatused",
        'reports': "Raamatupidamisaruanded",
        'extracts': 'Pangakonto väljavõtted',
        'contracts': 'Firma lepingud',
        'property': 'Kinnisvara (rent/omandus)',
        'purchases': 'Kulud',
        'sales': 'Sissetulekud',
        'offers': 'Hinnapakkumised',
        "languages": "Languages",
    },
    goto: "Vaata",
    gotoProfile: "Mine profiilile",
    archive: "Arhiiv",
    outArchive: "Välju arhiivist",
    toArchive: "Arhiveeri",
    deleteArchive: "Eemalda arhiivist",
    printDoc: "Prondi anklet väljä",
    loadDoc: "Vali dokument",
    main: {
        see_all: "Vaata kõik",
        profile: {
            label: "Profiili andmed"
        },
        news: {
            label: "Uudised"
        },
        calendar: {
            label: "Tulevad sündmused"
        }
    },
    widgets: {
        h1Label: "Vidinad",
        new: "Uus vidin",
        selectWidget: "Vali väljä vidin",
        note: {
            label: "Märkmik",
            lastSave: "Viimane salvestamine",
        },
    },
    workers: {
        skills: {
            outdoor_painting: "Välismaalitööd",
            indoor_painting: "Värvimistööd siseruumides",
            manual_plastering: "Käsitsi krohvimistööd",
            hardware_plastering: "Apparaadi krohvitööd",
            facade_plasteir_chain: "Fassaadikrohv võrguga",
            facade_plasteir_plasterboard: "Plastvõrguga fassaadikrohv",
            alignment: "Tasandamine",
            carpentry_simple: "Puusepatööd",
            carpentry_formwork: "Raketise puusepatööd",
            suspended_ceilings_giprok: "Ripplaed (kipsplaat)",
            suspended_ceilings_panels: "Ripplaed (paneelid)",
            partition_walls: "Vaheseinad",
            tile_waterproofing: "Plaadid + hüdroisolatsioon",
            floor_parquet: "Parketti paigaldamine",
            floor_laminate: "Laminaati paigaldamine",
            masonry: "Kivide ja telliste ladumine",
            concrete_works: "Betonitööd",
            concrete_installation: "Betoonelementide paigaldamine",
            reinforcement: "Armeerimine",
            roof_tiles: "Katusekate (katusekivi)",
            roof_metal: "Katusekate (metall)",
            bitumen_roof: "Bituumentööd (katus)",
            bitumen_plinth: "Bituumentööd (sokkel)",
            welding: "Keevitamine",
            diamond_cutting_drilling: "Teemantlõikamine ja puurimine",
            control_loader: "Tõstuki juhtimine",
            control_lift: "Tõstuki juhtimine",
            control_tractor: "Traktori juhtimine",
            control_transport: "Spetsstranspordi juhtimine",
            loader: "Tõstuk",
            lift: "Tõstuk",
            linoleum: "PVC",
            epoxy_coating: "Epoksiidkatetööd",
            electrics: "Elektritööd",
            plumbing: "Santehnilised tööd",
            sandblasting: "Liivapritsitööd",
            dismantling: "Demonteerimine/lõhkumine",
            asbestos: "Asbestitööd",
            cleaning: "Koristus",
        }
    },
    timings: {
        add: "Lisa uus aruanne",
        tabs: {
            piecework: "Tükitöö",
            hourly: "Tunnipalk",
            fixed: "Fikseeritud palk",
        }
    },
    statistic: "Statistika",
    accounting: {
        card: {
            scan: "Skaneerimine",
            worker: "Töötaja",
            category: "Kategooria",
            period: "Periood",
            bank: "Pank",
            date: "Kuupäev",
            datecontracts: "Lõpetamise kuupäev",
            datedocuments: "Allkirjastamise kuupäev",
            dateproperty: "Allkirjastamise kuupäev",
            datepurchases: "Makse kuupäev",
            dategarage: "Remondi kuupäev",
            dateCreate: "Väljastamise kuupäev",
            dateReceipt: "Kättesaamise kuupäev",
            dateRemind: "Meeldetuletuse kuupäev",
            dateDelivery: "Saabumise kuupäev",
            dueDate: "Kehtiv kuni",
            subject: "Teema",
            concluded: "Sõlmitud koos",
            name: "Nimetus",
            contractName: "Lepingu nimetus",
            documentName: "Dokumendi nimetus",
            author: "Raamatupidaja",
            status: "Staatus",
            percentDelay: "Viivis",
            statusPayed: "Makstud",
            statusCreated: "Saadetud",
            statusExpired: "Tähtaega ületanud",
            cost: "Hind",
            address: "Aadress",
            sum: "Summa",
            place: "Koht",
            tax: "Käibemaks",
            paymentMethod: "Makseviis",
            bankCard: "Pangakaart",
            bankTransfer: "Pangaülekanne",
            cash: "Sularaha",
            client: "Tellijä",
            object: "Objekt",
            numberLink: "Viitenumber",
            id: "Number",
            number: "Tellimuse nr",
            description: "Arve selgitus",
            comment: "Märkmed",
            term: "Tähtaeg",
            addService: "Lisa teenus",
            price: "Hind",
            discount: "Allahindlus(%)",
            type: "Kaup/teenus",
            typeMaterial: "Kaup",
            typeService: "Teenus",
            date_start: "Reisi alguskuupäev",
            date_end: "Reisi lõppkuupäev",
            time_start: "Algusaeg",
            time_end: "Lõpuaeg",
            way_time: "Reisi aeg",
            mileage: "Läbisõit",
            mileageStart: "Km alguses",
            mileageEnd: "Km lõpus",
            mileageTotal: "Kaugus km",
            departure: "Lähtepunkt",
            destination: "Sihtkoht",
            auto: "Auto reg nr",
            goal: "Sõidu eesmärk",
            material: "materjalid, kõik kinnitusdetailid ja kulumaterjalid",
            delivery: "materjali tarnimine laost või kauplusest objektile",
            tool: "instrument",
            lifts: "tõstukid",
            scaffolding: "telling",
            montage_scaffolding: "tellingute püstitamine ja demonteerimine",
            garbage: "prügi äravedu ja utiliseerimine",
            garbage_containers: "prügikonteinerid",
            security: "objekti valvamine",
            social_room: "sotsiaalruumid veega, riiete vahetamise ja söömise võimalus, tualett",
            unloading: "materjali mahalaadimine",
            spreading: "materjali levitamine objekti ümber",
            cleaning: "koristamine töömaal",
            numberBill: "Arve nr",
            bundle: "Tšekkide bogus",
            bundleSingle: "Üks tšekk",
            bundleMultiple: "2 ja rohkem",
            car: "Auto"
        },
        statistic: {
            count: "Kokku",
            categories: "Kategooriad",
            byCategory: "Kategooria järgi",
            perMonth: "Arveid kuu jooksul",
            clients: "Kliente",
            sum: "Summa käibemaksuta",
            sumTax: "Summa käibemaksuga"
        },
        reports: {
            label: "Raamatupidamisaruanded",
            new: "Uus aruanne",
            scan: "Aruanne skaneerimine",
            info: "Info aruannest",
        },
        extracts: {
            label: "Pangakonto väljavõtted",
            new: "Uus pangakonto väljävõte",
            scan: "Pangakonto väljävõte skaneerimine",
            info: "Info pangakonto väljävõtest",
        },
        contracts: {
            label: "Firma lepingud",
            new: "Uus leping",
            scan: "Lepingu skaneerimine",
            info: "Lepingu teave",
        },
        documents: {
            label: "Dokumendid",
            new: "Uus dokument",
            scan: "Dokumendi skaneerimine",
            info: "Dokumendi teave",
        },
        property: {
            label: "Kinnisvara (rent/omandus)",
            new: "Uus kinnisvaradokument",
            scan: "Dokumendi skaneerimine",
            info: "Dokumendi teave",
        },
        purchases: {
            label: "Kulud",
            new: "Uus tšekk",
            scan: "Tšekki skaneerimine",
            info: "Teave tšeki kohta",
        },
        sales: {
            label: "Sissetulekud",
            new: "Uus arve",
            scan: "Arve",
            number: "Arve nr"
        },
        offers: {
            label: "Hinnapakkumised",
            new: "Uus hinnapakkumine",
            scan: "Hinnapakkumise skaneerimine",
            number: "Hinnapakkumise nr"
        },
        waybills: {
            label: "Saatelehed",
            new: "НUus saateleht",
            scan: "Dokumendi skaneerimine",
            info: "Teave saatelehe kohta",
        },
        garage: {
            label: "Auto remont ja hooldus",
            new: "Uus dokument",
            scan: "Dokumendi skaneerimine",
            info: "Remonditeave",
        },
        details: "Detailed",
        serviceList: "Teenuste loend",
        newService: "Uus teenus",
        totalWithoutTax: "Kokku ilma käibemaksuta",
        total: "Kokku",
        fromClient: "Tellijalt"
    },
    account: "Isiklik kabinet",
    auth: "Autoriseerimine",
    registration: "Registreerimine",
    password: "Parool",
    forget: "Unustasid parooli?",
    enter: "Logi sisse",
    create: "Loo uus konto",
    stayIn: "Jääge süsteemi",
    logout: "Logi välja",
    other: "Muud",
    passport: "Pass",
    residence: "Eluluba",
    signup: {
        cancel: "Tühista registreerimine",
        hello: "Tere! Selle platvormiga töötamiseks jätke oma andmed",
        name: "Sinu nimi",
        lastname: "Sinu perekonnanimi",
        wantTitle: "Kas soovite meiega koostööd teha?",
        wantSubtitle: " Palun täitke vorm. Selle tegemiseks kulub vaid 15 minutit. Teie andmeid on vaja ainult töötamiseks ja teie mugavuse tagamiseks tööl. Kõrvalised seda infot ei näe",
        birthdate: "Sünnikuupäev",
        bankAccount: "Pangakonto number",
        whereTitle: "Kus te elate?",
        whereSubtitle: "Вvajame teie aadressi, et saaksime teid registreerida ja ettevõttest kirju saata",
        addressFin: "Soome aadress",
        addressFromFin: "Kuna olete Soomest, sisestage ainult oma Soome aadress",
        addressOwn: "Aadress kodumaal",
        additionalTitle: "Natuke lisainfot",
        additionalSubtitle: "Seda infot on meilgi vaja, sest põhjus, miks seda vaja on, kirjutatakse siia.",
        skillsTitle: "Hinda oma oskusi",
        skillsSubtitle: "Nii te saate ainult need projektid, millega saate hõlpsalt ja tõhusalt hakkama.",
        mainSpec: "Sinu põhiamet",
        selectSpec: "Valige amen nimekirjast",
        almostTitle: "Peaaegu kõik...",
        almostSubtitle: "Laadige üles loetletud tööloa dokumendid",
        photo: "Teie foto",
        photoSubtitle: "Veenduge, et teie nägu oleks selgelt nähtav ja oleksite näoga kaamera poole. Oleks parem, kui foto oleks nagu passi jaoks",
        residenceSubtitle: "Välismaalastele on see kohustuslik dokument",
        cardsTitle: "Ainult kaardid on jäänud",
        cardsSubtitle: " Valige kõik kaardid, mis teil on. Verokaardi omamine on kohustuslik! Kui loendist mõned kaardid puuduvad, saate need hiljem konto muutmisel üles laadida",
        congratTitle: "Palju õnne!",
        congratSubtitle: "Teie konto on edukalt loodud. Konto muutmise režiimis saate sisestada allesjäänud andmed või parandada olemasolevaid. Võite alustada platvormiga töötamist!",
        congratRentSubtitle: "Teie taotlus on vastuvõetud. Võtame teiega ühendust 7 tööpäeva jooksul, et arutada platvormi rentimise üksikasju. Samuti teil alustatakse 14-päevane prooviperiood",
        wantRentTitle: "Soovite rentida platvormi?",
        wantRentSubtitle: "Selleks täitke küsimustik oma ettevõtte kohta, et muuta platvorm oma tegevuse jaoks kõige mugavamaks. Küsimustiku täitmine võtab aega umbes 5 minutit.",
        contactInfoTitle: "Kontaktandmed",
        contactInfoSubtitle: "Kuidas me saame teiega ühendust võtta?",
        detailsSubtitle: "Maksuarve koostamiseks",
    },

    //для старой версии
    Index: {
        h1Label: "Koduleht",
        hello: "Tere tulemast, ",
        todayLabel: "Tänaseks",
        statistics: {
            news: {
                label: "Uudised: ",
                text: "uudiseid"
            },
            workers: {
                label: "Töötajad: ",
                all: "töötajaid",
                new: "Täna uusi täätajaid",
                text: "Töötab: ",
            },
            clients: {
                label: "Kliendid: ",
                all: "Kliente",
                new: "Tänaseks uusi",
            },
            objects: {
                label: "Töömaad: ",
                all: "töömaade",
                text: "Töös",
            },
            calendar: {
                label: "Kalender: ",
                all: "sündmuste",
                week: "Sellel nädalal",
                today: "Täna",
            },
        },
    },
    settings: {
        'holidays': 'Puhkus',
        'language-settings': 'Languages',

        'workTypes': 'Tööde tüübid',
        selectThemeLabel: "Teema valik",
        selectLangLabel: "Liidese keel",
        languages: {
            rus: "Vene",
            eng: "Inglise",
            fin: "Soome",
            est: "Eesti",
            ukr: "Ukraina",
            swe: "Rootsi",
        },
        groups: "Kasutajagrupi haldamine",
        workerPosition: "Töötajate ametid",
        contactPosition: "Kontaktide ametid",
        chequeCategories: "Maksutšekkide kategooriaid",
        reportsCategories: "Raamatupidamisaruannete kategooriad",
        goals: "Sõidu eesmärgid",
        banks: "Pangad",
        terms: "Tähtajad",
        tax: "TAX",
        cards: "Kaardid",
        read: "Lugemine",
        edit: "Muudatus",
        absenceReasons: "Puudumise põhjus",
        skills: "Oskused",
        companyData: "Ettevõtte andmed",
        tripTime: "Reisi aeg aruandluseks",
    },

    invalid_credentials: "Kehtetu e-posti aadress või parool. Kontrollige sisestatud andmeid",
    recoveryPassword: "Parooli taastamine",
    repeatPassword: "Korda salasõna",
    emailNotification: "Teie e-posti aadressile on saadetud link parooli taastamiseks",
    recoveryButton: "Taste parool",
    samePasswordRule: "Paroolid ei ühti",
    min8Rule: "Vähemalt 8 tähemärki",
    notFound: "Lehekülg ei ole leitud",
    notFoundSubtitle: "Näib, et klõpsasite lingil, mida pole olemas, või sisestasite vale aadressi",
    goMain: "Avalehele",
    editingComment: "Kommentaari redakteerimine",
    pause: "Vaheaeg",
    minutes: "min",
    hour: "t",
    hours: "Tunde",
    sortDescending: "alla",
    sortAscending: "ülesse",
    perPage: "Objekte lehel",
    details: "Rekvisiidid",
    addDetails: "Lisa uued rekvisiidid",
    editDetails: "Muuda rekvisiidid",
    selectType: "Rekvisiidi tüüp",
    "e-account": "E-arve",
    detailAddress: "E-arvede aadress",
    operator: "Operaator",
    operator_id: "Operaatori ID",
    invoice_address: "Email",
    client_name: "Kliendi nimi",
    bank: "Pank",
    bic: "BIC",
    iban: "IBAN",
    addLink: "Lisa uus link",
    editLink: "Redakteeri link",
    addCategory: "Lisa kategooria",
    link: "Link",
    newComments: "Uued kommentaarid",
    notFoundAnswer: "Ei leidnud vastust oma küsimusele?",
    text: "Tekst",
    reason: "Puudumise põhjusy",
    showQua: "Kuvada ankeedis",

    technical: "Veebisaidil on käimas tehniline töö. Palun tulge hiljem tagasi",
    technicalTime: "Tööd kestavad 13-23",
    error500: "Sisemine serveri viga",
    selectShownHeaders: "Kuvatud väljade valik",
    preview: "Eelvaade",
    payment: "Makse",
    sendToEmail: "Saada reaalile",
    send: "Saada reaalile",
    simpleReg: "Lühike registreerimine",
    history: "Muutuste ajalugu",
    author: "Autor",
    beforeChanges: "Enne muudatusi",
    afterChanges: "Pärast muudatusi",
    answer: "Vastus kommentaarile",
    markRead: "Märkige loetuks ",
    read_timings: "Lubada juurdepääs aruannetele",
    productCode: "Toote kood",
    eanCode: "EAN",
    shops: "Kauplused",
    shop: "Kauplus",
    addShop: "Lisa kauplus",
    sellers: "Müüjäd",
    seller: "Müüjä",
    addSeller: "Lisa müüjä",
    addProduct: "Lisa toode",
    connection: "Kontakt",
    rentPlatform: "Rendi platvorm",
    contactPerson: "Kontaktisik",
    contactPersonSubtitle: "Sellest isikust saab süsteemi esimene kasutaja ja administraator",
    subdomain: "Alamdomeen",
    lastLogin: "Viimane sisselogimine",
    products: "Kaubad",
    addBusinessCard: "Lisa visiitkaart",
    frontPhoto: "Pilt eestpoolt",
    backPhoto: "Pilt tagapoolt",
    todoComment: "Kommentaar lisatakse objektile",
    addTask: "Lisa ülesanne",
    workerLimit: "Tööliste hulk",
    functions: "Valikud",
    paid_until: "Makstud kuni",
    domain: "Domeeninimi",
    onTrial: "Prooviperiood",
    choose: "Vali",
    chooseTariff: "Vali tariif",
    chosen: "Valitud",
    rentInfo: "Laenutusteave",
    createdDateTenant: "Registreerimise kuupäev",
    tariffPlan: "Tariif",
    changeTariff: "Muuda tariif",
    pay_platform: "Platvormi kasutamise jätkamiseks palun tasuge arve",
    archiveable: "Arhiveeri 7 päeva pärast",
    success: "Maksmine õnnestus",
    error: "Makseviga",
    contactAdmin: "Võtke ühendust administraatoriga",
    stripe: "Tootekood Stripe",
    pay: "Maksa",
    uploadedFiles: "Üöeslaetud failid",
    safePassword: "Seiffi parool",
    updatePassword: "Uuenda parooli",
    invalidPassword: "Vale pariol",
    safeAlert: "Me ei soovita siia salvestada paroole ja muud olulist teavet..\n Work24 administratsioon ei vastuta seifis olevate andmete ohutuse eest.",
    dateTimings: "Aruande kuupäevad",
    withArch: "Kaaludes arhiveerimise",
    copy: "Kopeeri",
    timingChanges: "Tunniaruande muudatused",
    checkIn: "Check in",
    checkOut: "Check out",
    workerOnObject: "Objektil alates ",
    showGeo: "Näita asukoht",
    endWithoutReport: "Lõpeta ilma aruandeta",
    translate: "Tōlkida",
    showOriginal: "Näita originaali",
    repeat: "Korda",
    once: "Üks kord",
    weekly: "Iganädalane",
    monthly: "Kuu",
    yearly: "Aasta",
    until: "Kuni",
    showHistory: "Näita ajalugu",
    contactsVisible: "Tee kontaktid nähtavaks",
    geoError: "Geolokatsiooni viga",
    workerLimitError: "Lubatud töötajate arv süsteemis on ületatud",
    changeDate: "Muuda kuupäev",
    downloadAllFiles: "Laadi alla kõik pildid",
    addSignature: "Skannima allkiri",
    signature: "Allkiri",
    permissionError: "Juurdepääs keelatud",
    methodNotAllowedError: "Meetod pole lubatud",
    unexpectedError: "Ootamatu viga",
    userExists: "Kasutaja on juba olemas",
    tripTime: "Reisi aeg",

    "dgantt": {
        "title": "Diagramm",
        "tasks": "Ülesanded",
        'workType': 'töö tüüp',

    },
    "months": {
        "Jan": "Jaanuar",
        "Feb": "Veebruar",
        "Mar": "Märts",
        "Apr": "Aprill",
        "May": "Mai",
        "Jun": "Juuni",
        "Jul": "Juuli",
        "Aug": "August",
        "Sep": "September",
        "Oct": "Oktoober",
        "Nov": "November",
        "Dec": "Detsember"
    },
    "days": {
        "Mon": "Esm",
        "Tue": "Tei",
        "Wed": "Kol",
        "Thu": "Nel",
        "Fri": "Ree",
        "Sat": "Lau",
        "Sun": "Püh"
    },

    "days_genitive": 'päeva',
    "filter": "Filter",
    expiredDocuments: "Tähtaja ületanud dokumendid",
    upcomingAbsence: "Tulevased puhkused",
    'selectedSection': 'Valitud sektsioon',

    'holiday-work': 'Nädalavahetuse töö',
    organizationCar: "Organisatsiooni masin",
    personal: "Isiklik",
    fromOrganization: "Organisatsioonid",
    maybe: "võib-olla mõtlesite",
    partners: "Partnerid",
    fromNotes: "Märkmikust",
    invitations: "Kutsed",
    from: "Alates",
    accept: "Aktsepteeri",
    reject: "Keeldu",
    find: "Leia",
    contractor: "Contractor",
}
//# sourceMappingURL=est.js.map
